import {
  Component,
  Input,
  OnInit,
  signal,
  computed,
  WritableSignal,
} from '@angular/core';

import { Router } from '@angular/router';
import {
  IonContent,
  IonButton,
  IonIcon,
  IonItem,
  IonLabel,
  IonAccordionGroup,
  IonAccordion,
  ModalController,
} from '@ionic/angular';
import { FAQ_SECTIONS, resolveFaqSectionFromUrl } from '@app/constants/faq.constants';
import { FaqItem, FaqSection, FaqSectionId } from '@app/types/faq.types';

@Component({
  selector: 'app-faq-modal',
  templateUrl: './faq-modal.component.html',
  styleUrls: ['./faq-modal.component.scss'],
  standalone: true,
  imports: [
    IonContent,
    IonButton,
    IonIcon,
    IonItem,
    IonLabel,
    IonAccordionGroup,
    IonAccordion
],
})
export class FaqModalComponent implements OnInit {
  @Input() initialSectionId?: FaqSectionId;

  public sections: FaqSection[] = FAQ_SECTIONS;
  public activeSectionId: WritableSignal<FaqSectionId> = signal('forecast-lab');
  public searchQuery: WritableSignal<string> = signal('');

  public activeSection = computed(() => {
    return this.sections.find((s) => s.id === this.activeSectionId()) || this.sections[0];
  });

  public filteredItems = computed(() => {
    const query = this.searchQuery().toLowerCase().trim();
    const items = this.activeSection().items;
    if (!query) return items;
    return items.filter(
      (item) =>
        item.question.toLowerCase().includes(query) ||
        item.answer.toLowerCase().includes(query) ||
        item.tags?.some((t) => t.toLowerCase().includes(query))
    );
  });

  constructor(
    private modalCtrl: ModalController,
    private router: Router
  ) {}

  ngOnInit(): void {
    if (this.initialSectionId) {
      this.activeSectionId.set(this.initialSectionId);
    } else {
      this.activeSectionId.set(resolveFaqSectionFromUrl(this.router.url));
    }
  }

  selectSection(id: FaqSectionId): void {
    this.activeSectionId.set(id);
    this.searchQuery.set('');
  }

  onSearchInput(event: any): void {
    this.searchQuery.set(event.target.value || '');
  }

  clearSearch(): void {
    this.searchQuery.set('');
  }

  getItemCount(sectionId: FaqSectionId): number {
    const sec = this.sections.find((s) => s.id === sectionId);
    return sec ? sec.items.length : 0;
  }

  dismiss(): void {
    this.modalCtrl.dismiss();
  }

  async downloadManual(): Promise<void> {
    const fileUrl = 'assets/ordersmart-cockpit-user-manual.pdf';
    const fileName = 'ordersmart-cockpit-user-manual.pdf';
    try {
      const response = await fetch(fileUrl);
      if (!response.ok) throw new Error('File download failed');
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (err) {
      console.error('Error downloading the PDF:', err);
    }
  }
}
